import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3 md:py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
                </div>
              )}
              {!isLast && item.to ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={`whitespace-nowrap ${isLast ? 'text-foreground-300 font-medium' : 'text-foreground-500'}`}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}